export var E_NoticeConfigurationOpenMode;
(function (E_NoticeConfigurationOpenMode) {
    E_NoticeConfigurationOpenMode["NewTab"] = "new_tab";
    E_NoticeConfigurationOpenMode["CurrentTab"] = "current_tab";
})(E_NoticeConfigurationOpenMode || (E_NoticeConfigurationOpenMode = {}));
export var E_NotificationMsgReadWay;
(function (E_NotificationMsgReadWay) {
    /**
     * 批量已读
     */
    E_NotificationMsgReadWay["batch"] = "batch";
    /**
     * 单个已读
     */
    E_NotificationMsgReadWay["single"] = "single";
})(E_NotificationMsgReadWay || (E_NotificationMsgReadWay = {}));
